export default function authFormHeader() {
  const user = JSON.parse(localStorage.getItem("token"));

  if (user) {
    // For Spring Boot back-end
    // return { Authorization: "Bearer " + user.accessToken };

    // for Node.js Express back-end
    return {
      "Content-Type": "multipart/form-data",
      Authorization: user,
      Url: window.location.href,
    };
  } else {
    return {};
  }
}
